import React, { useEffect, useState } from "react";
import { ClockIcon, UsersIcon } from "lucide-react";
const TOTAL_CUPOS = 200;
function useCountdown(seconds: number) {
  const [remaining, setRemaining] = useState(seconds);
  useEffect(() => {
    const id = setInterval(() => {
      setRemaining(r => r > 0 ? r - 1 : 0);
    }, 1000);
    return () => clearInterval(id);
  }, []);
  const h = Math.floor(remaining / 3600);
  const m = Math.floor(remaining % 3600 / 60);
  const s = remaining % 60;
  return {
    h,
    m,
    s
  };
}
const pad = (n: number) => n.toString().padStart(2, "0");
export function Countdown() {
  const {
    h,
    m,
    s
  } = useCountdown(2 * 3600 + 47 * 60 + 12);
  const cuposLeft = 37;
  const pct = Math.round(cuposLeft / TOTAL_CUPOS * 100);
  return <div className="rounded-xl border border-[#8bc34a]/40 bg-[#0f2c4a] p-4" data-id="element-67" data-mp="374vu585u2k1o">
      <div className="flex items-center justify-center gap-1.5 text-[#8bc34a]" data-id="element-68" data-mp="10cuyzzngnzcg">
        <ClockIcon className="h-4 w-4" data-id="element-69" data-mp="15add04gc54rb" />
        <span className="text-xs font-black uppercase tracking-wide" data-id="element-70" data-mp="159bx9modju39">
          La oferta termina en
        </span>
      </div>

      <div className="mt-2 flex items-center justify-center gap-2" data-id="element-71" data-mp="t2d3x7nkpwls">
        {[{
        v: h,
        l: "Hs"
      }, {
        v: m,
        l: "Min"
      }, {
        v: s,
        l: "Seg"
      }].map(u => <div key={u.l} className="text-center" data-id="element-72" data-mp="12s54qjm9nlyp">
            <div className="min-w-[54px] rounded-lg bg-white px-2 py-1.5 text-2xl font-black tabular-nums text-[#0f2c4a]" data-id="element-73" data-mp="12sety4zhlp3c">
              {pad(u.v)}
            </div>
            <div className="mt-1 text-[10px] font-bold uppercase text-slate-300" data-id="element-74" data-mp="a40vxp8eesrs">
              {u.l}
            </div>
          </div>)}
      </div>

      <div className="mt-4" data-id="element-75" data-mp="o0w9nuzlh8e6">
        <div className="mb-1.5 flex items-center justify-between text-xs font-bold text-slate-200" data-id="element-76" data-mp="k0vto5wukp50">
          <span className="flex items-center gap-1" data-id="element-77" data-mp="1zhmhtjnkwaaf">
            <UsersIcon className="h-3.5 w-3.5 text-[#8bc34a]" data-id="element-78" data-mp="1zgcjctctd039" />
            Cupos restantes
          </span>
          <span className="text-[#8bc34a]" data-id="element-79" data-mp="1vin3x9jvd36u">
            {cuposLeft} de {TOTAL_CUPOS}
          </span>
        </div>
        <div className="h-3 w-full overflow-hidden rounded-full bg-white/15" data-id="element-80" data-mp="x4rddlfh7dyt">
          <div className="h-full rounded-full bg-[#8bc34a] transition-all" style={{
          width: `${pct}%`
        }} data-id="element-81" data-mp="x6udiyacenh9" />
        </div>
        <p className="mt-1.5 text-center text-[11px] text-slate-300" data-id="element-82" data-mp="165pjqaddzxkk">
          ¡Se están agotando! Asegurá el tuyo hoy.
        </p>
      </div>
    </div>;
}